"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "la-spezia": {
    "5353b656": [{
      "hkey": "1c45635f",
      "slug": "bragarina-la-pianta",
      "name": "Bragarina-La Pianta",
      "primary": true,
      "skipSearch": false
    }],
    "bragarina": [{
      "hkey": "1c45635f",
      "slug": "bragarina-la-pianta",
      "name": "Bragarina-La Pianta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "674ccf8d": [{
      "hkey": "4f1e20f3",
      "slug": "buggi-costa-di-murlo-pegazzano",
      "name": "Buggi-Costa di Murlo-Pegazzano",
      "primary": true,
      "skipSearch": false
    }],
    "buggi": [{
      "hkey": "4f1e20f3",
      "slug": "buggi-costa-di-murlo-pegazzano",
      "name": "Buggi-Costa di Murlo-Pegazzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "la-spezia"
    }],
    "a8ac7eee": [{
      "hkey": "1f86fa8a",
      "slug": "colli-vicci-poggio",
      "name": "Colli-Vicci-Poggio",
      "primary": true,
      "skipSearch": false
    }],
    "colli-vicci": [{
      "hkey": "1f86fa8a",
      "slug": "colli-vicci-poggio",
      "name": "Colli-Vicci-Poggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "86ec7c5a": [{
      "hkey": "9493115b",
      "slug": "fabiano-la-lizza",
      "name": "Fabiano-La Lizza",
      "primary": true,
      "skipSearch": false
    }],
    "fabiano": [{
      "hkey": "9493115b",
      "slug": "fabiano-la-lizza",
      "name": "Fabiano-La Lizza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "la-spezia"
    }],
    "67f8332f": [{
      "hkey": "9493115b",
      "slug": "fabiano-la-lizza",
      "name": "Fabiano-La Lizza",
      "primary": true,
      "skipSearch": false
    }],
    "fabiano-alto-lizza": [{
      "hkey": "9493115b",
      "slug": "fabiano-la-lizza",
      "name": "Fabiano-La Lizza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7f3b53ff": [{
      "hkey": "739fefd9",
      "slug": "fossitermi-la-scorza",
      "name": "Fossitermi-La Scorza",
      "primary": true,
      "skipSearch": false
    }],
    "fossitermi": [{
      "hkey": "739fefd9",
      "slug": "fossitermi-la-scorza",
      "name": "Fossitermi-La Scorza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7cf18238": [{
      "hkey": "3133f212",
      "slug": "la-foce-sant-anna",
      "name": "La Foce-Sant'Anna",
      "primary": true,
      "skipSearch": false
    }],
    "la-foce": [{
      "hkey": "3133f212",
      "slug": "la-foce-sant-anna",
      "name": "La Foce-Sant'Anna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7d2951f7": [{
      "hkey": "739fefd9",
      "slug": "fossitermi-la-scorza",
      "name": "Fossitermi-La Scorza",
      "primary": true,
      "skipSearch": false
    }],
    "la-scorza": [{
      "hkey": "739fefd9",
      "slug": "fossitermi-la-scorza",
      "name": "Fossitermi-La Scorza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "la-spezia"
    }],
    "c1f43338": [{
      "hkey": "6cc95103",
      "slug": "marinasco-san-rocco-sarbia",
      "name": "Marinasco-San Rocco-Sarbia",
      "primary": true,
      "skipSearch": false
    }],
    "marinasco-sarbia": [{
      "hkey": "6cc95103",
      "slug": "marinasco-san-rocco-sarbia",
      "name": "Marinasco-San Rocco-Sarbia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f7ae363e": [{
      "hkey": "1767c84e",
      "slug": "cadimare-marola",
      "name": "Cadimare-Marola",
      "primary": true,
      "skipSearch": false
    }],
    "marola-acquasanta": [{
      "hkey": "1767c84e",
      "slug": "cadimare-marola",
      "name": "Cadimare-Marola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "210af72d": [{
      "hkey": "07b12226",
      "slug": "mazzetta-kennedy",
      "name": "Mazzetta-Kennedy",
      "primary": true,
      "skipSearch": false
    }],
    "mazzetta": [{
      "hkey": "07b12226",
      "slug": "mazzetta-kennedy",
      "name": "Mazzetta-Kennedy",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7e2d60b2": [{
      "hkey": "b43ad265",
      "slug": "montepertico-vailunga",
      "name": "Montepertico-Vailunga",
      "primary": true,
      "skipSearch": false
    }],
    "montepertico": [{
      "hkey": "b43ad265",
      "slug": "montepertico-vailunga",
      "name": "Montepertico-Vailunga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "199a5ebd": [{
      "hkey": "ae1b81e5",
      "slug": "muggiano-ruffino",
      "name": "Muggiano-Ruffino",
      "primary": true,
      "skipSearch": false
    }],
    "pagliari-ruffino-muggiano": [{
      "hkey": "ae1b81e5",
      "slug": "muggiano-ruffino",
      "name": "Muggiano-Ruffino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "416532a0": [{
      "hkey": "4f1e20f3",
      "slug": "buggi-costa-di-murlo-pegazzano",
      "name": "Buggi-Costa di Murlo-Pegazzano",
      "primary": true,
      "skipSearch": false
    }],
    "pegazzano": [{
      "hkey": "4f1e20f3",
      "slug": "buggi-costa-di-murlo-pegazzano",
      "name": "Buggi-Costa di Murlo-Pegazzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "la-spezia"
    }],
    "327da333": [{
      "hkey": "6cf2375d",
      "slug": "san-venerio-carozzo",
      "name": "San Venerio-Carozzo",
      "primary": true,
      "skipSearch": false
    }],
    "san-venerio": [{
      "hkey": "6cf2375d",
      "slug": "san-venerio-carozzo",
      "name": "San Venerio-Carozzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5536f61b": [{
      "hkey": "6cc95103",
      "slug": "marinasco-san-rocco-sarbia",
      "name": "Marinasco-San Rocco-Sarbia",
      "primary": true,
      "skipSearch": false
    }],
    "sarbia": [{
      "hkey": "6cc95103",
      "slug": "marinasco-san-rocco-sarbia",
      "name": "Marinasco-San Rocco-Sarbia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "la-spezia"
    }],
    "3dc4cdde": [{
      "hkey": "fbcca4ca",
      "slug": "melara-termo",
      "name": "Melara-Termo",
      "primary": true,
      "skipSearch": false
    }],
    "termo-limone-melara": [{
      "hkey": "fbcca4ca",
      "slug": "melara-termo",
      "name": "Melara-Termo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8ac9744e": [{
      "hkey": "0f23ce54",
      "slug": "valdellora-antoniana",
      "name": "Valdellora-Antoniana",
      "primary": true,
      "skipSearch": false
    }],
    "valdellora": [{
      "hkey": "0f23ce54",
      "slug": "valdellora-antoniana",
      "name": "Valdellora-Antoniana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5d5a24ad": [{
      "hkey": "71249e96",
      "slug": "umberto-i",
      "name": "Umberto I",
      "primary": true,
      "skipSearch": false
    }],
    "zona-centro": [{
      "hkey": "71249e96",
      "slug": "umberto-i",
      "name": "Umberto I",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "db0748e1": [{
      "hkey": "344fdb7d",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "zona-pedonale": [{
      "hkey": "344fdb7d",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "la-spezia"
    }]
  }
};
exports["default"] = _default;